import React, { createContext, useContext, useEffect, useState } from "react";

const AuthCtx = createContext(null);

const LS_PINS = "meatbook_pins_v1";
const LS_ROLE = "meatbook_role_v1";

const DEFAULT_PINS = { owner: "9999", staff: "1234" };

const loadPins = () => {
  try {
    const raw = localStorage.getItem(LS_PINS);
    if (!raw) return DEFAULT_PINS;
    const obj = JSON.parse(raw);
    return { owner: obj.owner || DEFAULT_PINS.owner, staff: obj.staff || DEFAULT_PINS.staff };
  } catch {
    return DEFAULT_PINS;
  }
};

const STAFF_ALLOWED = new Set(["/pos", "/wholesale", "/party-orders"]);

export const isPathAllowedForRole = (path, role) => {
  if (role === "owner") return true;
  if (role === "staff") return STAFF_ALLOWED.has(path);
  return false;
};

export function AuthProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem(LS_ROLE));
  const [pins, setPins] = useState(loadPins);

  useEffect(() => {
    // Persist default pins on first run
    if (!localStorage.getItem(LS_PINS)) {
      localStorage.setItem(LS_PINS, JSON.stringify(DEFAULT_PINS));
    }
  }, []);

  const login = (pinValue) => {
    const p = String(pinValue || "").trim();
    if (p && p === pins.owner) {
      setRole("owner");
      localStorage.setItem(LS_ROLE, "owner");
      return "owner";
    }
    if (p && p === pins.staff) {
      setRole("staff");
      localStorage.setItem(LS_ROLE, "staff");
      return "staff";
    }
    return null;
  };

  const logout = () => {
    setRole(null);
    localStorage.removeItem(LS_ROLE);
  };

  const updatePins = (next) => {
    const merged = { ...pins, ...next };
    setPins(merged);
    localStorage.setItem(LS_PINS, JSON.stringify(merged));
  };

  return (
    <AuthCtx.Provider
      value={{ role, pins, login, logout, updatePins }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
